import React, { FC } from 'react';

interface CopyrightProps {
    className?: string;
}
export const Copyright: FC<CopyrightProps> = ({ className }) => {
    const years = `2016\u2013${new Date().getFullYear()}`;
    return (
        <span className={className}>
            <bdo dir="ltr">©</bdo>
            &nbsp;
            <bdo dir="ltr">{years}</bdo>
            &nbsp;
            <bdo dir="ltr">Allplay (OOO “Allmedia Safe Service”)</bdo>
        </span>
    );
};
